const dev = {
  s3: {
    REGION: "us-east-1",
    BUCKET: "notes-app-2-api-dev-attachmentsbucket-6h0qf2cytyy"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://ow5a5740w9.execute-api.us-east-1.amazonaws.com/dev"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_OVKSFg1aj",
    APP_CLIENT_ID: "5iuhsbr05pk4up55oqadvledkv",
    IDENTITY_POOL_ID: "us-east-1:5b03c472-6c00-441f-a64b-8bb8f513d95d"
  },
  STRIPE_KEY: "pk_test_vbduopWdxkqRzlSUXYkOx0GF"
};

const prod = {
  s3: {
    REGION: "us-east-1",
    BUCKET: "notes-app-2-api-prod-attachmentsbucket-10wdayoxcvhh5"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://zkn388fdxj.execute-api.us-east-1.amazonaws.com/prod"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_qRy8Veoj0",
    APP_CLIENT_ID: "2sc8plcu4cavfutp11ebs8vs3c",
    IDENTITY_POOL_ID: "us-east-1:71c53439-4c1e-4b24-b1b9-7e689a8b0fc1"
  },
  STRIPE_KEY: "pk_test_vbduopWdxkqRzlSUXYkOx0GF"
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};



// WEBPACK FOOTER //
// ./src/config.js